import { Injectable, Inject } from '@angular/core';
import { environment } from '../../environments/environment';
import { HttpClient } from '@angular/common/http';
import { LoggingService } from '../shared/services/logging/logging.service';
import { Observable, of } from 'rxjs';
import { MessageDeliveryType } from './message-delivery-type.model';

@Injectable({
    providedIn: 'root'
})
export class MessageDeliveryTypeService {
    private uri = `${environment.apiLocation}/MessageDelivery`;
    constructor(
        @Inject(HttpClient) private http: HttpClient,
        @Inject(LoggingService) private log: LoggingService
    ) {}

    get(): Observable<Array<MessageDeliveryType>> {
        return this.http.get<Array<MessageDeliveryType>>(this.uri) || of([]);
    }
}
